
export default function Habitat() {
  const habitats = [
    {
      title: 'Rainforest Canopy',
      description: 'Leachianus geckos are strictly arboreal, living high in the rainforest canopy. They spend their entire lives in trees, rarely descending to the ground, utilizing their strong grip and prehensile tail for navigation.',
      image: 'https://readdy.ai/api/search-image?query=lush%20tropical%20rainforest%20canopy%20view%20from%20below%20looking%20up%20at%20dense%20green%20foliage%20and%20tree%20branches%20misty%20atmosphere%20new%20caledonia%20forest%20simple%20natural%20background&width=500&height=400&seq=habitat-canopy-003&orientation=landscape',
      color: 'bg-emerald-50'
    },
    {
      title: 'Climate Conditions',
      description: 'Their native habitat features warm temperatures ranging from 72-78°F with high humidity levels of 60-80%. The consistent moisture and moderate temperatures of New Caledonia create ideal conditions for these geckos.',
      image: 'https://readdy.ai/api/search-image?query=misty%20tropical%20rainforest%20with%20water%20droplets%20on%20leaves%20humid%20atmosphere%20fog%20in%20forest%20temperature%20and%20moisture%20concept%20simple%20clean%20natural%20background&width=500&height=400&seq=habitat-climate-004&orientation=landscape',
      color: 'bg-sky-50'
    },
    {
      title: 'Territory Range',
      description: 'Endemic to New Caledonia, these geckos inhabit various islands including Grande Terre, Isle of Pines, and surrounding smaller islands. Each island population has developed unique characteristics and color variations.',
      image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20tropical%20island%20coastline%20with%20lush%20green%20forest%20new%20caledonia%20landscape%20geographic%20territory%20map%20concept%20simple%20clean%20background&width=500&height=400&seq=habitat-territory-005&orientation=landscape',
      color: 'bg-amber-50'
    }
  ];

  return (
    <section id="habitat" className="py-16 md:py-32 px-4 md:px-8 lg:px-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <div className="flex justify-center mb-4">
            <i className="ri-leaf-line text-4xl md:text-5xl text-emerald-600"></i>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-4">Natural Habitat</h2>
          <p className="text-lg md:text-xl text-gray-600">Understanding their rainforest home</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {habitats.map((habitat, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="h-48 md:h-64 lg:h-72 overflow-hidden">
                <img
                  src={habitat.image}
                  alt={habitat.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className={`${habitat.color} p-6 md:p-8`}>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">{habitat.title}</h3>
                <p className="text-gray-700 leading-relaxed mb-4 md:mb-6 text-sm md:text-base">{habitat.description}</p>
                <button className="text-[#B8E986] font-semibold flex items-center gap-2 hover:gap-3 transition-all whitespace-nowrap cursor-pointer">
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
